import { some } from '@utils/some';
import { required } from '@utils/validators';

type Guest = {
  title: string;
  firstName: string;
  lastName: string;
  room: number;
};

export const validateGuestFields = (guest: Guest) => {
  return {
    title: required(guest.title),
    firstName: required(guest.firstName),
    lastName: required(guest.lastName),
  };
};

export const validateFirstGuestPerRoom = (guests: Guest[]) => {
  const roomsEncountered: { [roomNumber: string]: boolean } = {};

  return guests.map((guest) => {
    const isFirstInRoom = !roomsEncountered[guest.room];
    if (isFirstInRoom) {
      roomsEncountered[guest.room] = true;
      return validateGuestFields(guest);
    }
    return {};
  });
};

export const validateGuests = (values: { guests: Guest[] }) => {
  if (!values.guests?.length) {
    return { guests: { _error: required() } };
  }

  const guestErrors = validateFirstGuestPerRoom(values.guests);

  const hasErrors = some(guestErrors, (error) =>
    some(Object.values(error), (value) => value !== undefined)
  );

  return hasErrors ? { guests: guestErrors } : {};
};
